import {
  DialogContent,
  Table,
  TableBody,
  TableContainer,
  TableHead,
} from '@mui/material';
import * as React from 'react';

import { useSxStyles } from './useStyles';

export interface TableRowComponentProps<TR> {
  tableRow: TR;
  isTabDisabled?: boolean;
}

export interface TableHeaderComponentProps {}

export interface Props<TR> {
  tableRows?: TR[];
  isTabDisabled?: boolean;
}

export const AllTableDialogContentComponentFactory = <TR extends {}>(
  TableRowComponent: React.ComponentType<TableRowComponentProps<TR>>,
  getIdentifier: (item: TR) => string | number,
  TableHeaderComponent?: React.ComponentType<TableHeaderComponentProps>,
) => {
  const AllTableDialogContent: React.FC<Props<TR>> = ({
    tableRows,
    isTabDisabled,
  }) => {
    const sxStyles = useSxStyles();

    return (
      <DialogContent sx={sxStyles.dialogContentSimpleTable}>
        <div data-cy="all-table-items-dialog-content">
          <TableContainer sx={sxStyles.tableContainer}>
            <Table>
              {TableHeaderComponent && (
                <TableHead>
                  <TableHeaderComponent />
                </TableHead>
              )}
              <TableBody>
                {tableRows &&
                  tableRows.map((tableRow) => (
                    <TableRowComponent
                      key={getIdentifier(tableRow)}
                      tableRow={tableRow}
                      isTabDisabled={isTabDisabled}
                    />
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </DialogContent>
    );
  };

  return AllTableDialogContent;
};
